import { populate } from 'populate';import dragonBones from 'pixi-dragonbones';

const raw = {
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: '05010f98-1625-496a-859f-8d4933433706',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: -10,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: '9c1b3ed7-12f0-4a64-9b98-c5744cf00476',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -665,
      y: -469,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Christmas_snow_BG',
      parent: '05010f98-1625-496a-859f-8d4933433706',
      data: ''
    },
    {
      id: 'e9297e63-cf8c-4e34-8c9e-c15f6811e703',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -665,
      y: 194,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Christmas_snow_1_layer',
      parent: '05010f98-1625-496a-859f-8d4933433706',
      data: ''
    },
    {
      id: 'b1e6fd05-7b57-48b5-b0d8-c1fe0947498e',
      type: 'Container',
      name: 'sideContainer',
      nameSpace: '',
      className: '',
      x: 300,
      y: -248,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '05010f98-1625-496a-859f-8d4933433706',
      data: ''
    },
    {
      id: '4bc94f47-a720-4b44-b94b-aa2582c028bd',
      type: 'NineSlicePlane',
      name: 'bg',
      nameSpace: '',
      className: '',
      x: 0,
      y: 35,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 388,
        y: 319
      },
      width: 775,
      height: 638,
      leftWidth: 90,
      topHeight: 100,
      rightWidth: 90,
      bottomHeight: 100,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'UI_Christmas_window',
      parent: '05010f98-1625-496a-859f-8d4933433706',
      data: ''
    },
    {
      id: 'da99047f-7c99-48ff-8fbd-f5e8356f539e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 17,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'popup_underlay',
      parent: '05010f98-1625-496a-859f-8d4933433706',
      data: ''
    },
    {
      id: '0d02c613-ef36-4e94-86a4-e7245b6090dc',
      type: 'Sprite',
      name: 'headerBg',
      nameSpace: '',
      className: '',
      x: 10,
      y: -259,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Christmas_top_stars',
      parent: '05010f98-1625-496a-859f-8d4933433706',
      data: ''
    },
    {
      id: 'f0c84e06-b3a4-479c-a1da-99e60acb8ab8',
      type: 'Sprite',
      name: 'hardLevelNumberBg',
      nameSpace: '',
      className: '',
      x: 0,
      y: -172,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'level_place_hard',
      parent: '05010f98-1625-496a-859f-8d4933433706',
      data: ''
    },
    {
      id: '6fa403cc-c81c-4d52-8515-91dc3e7323fc',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'failContainers',
      x: 0,
      y: -80,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '05010f98-1625-496a-859f-8d4933433706',
      data: ''
    },
    {
      id: '6b8770b9-2782-4329-8551-7b5c5ee148f9',
      type: 'Text',
      name: 'levelText',
      nameSpace: '',
      className: '',
      x: 0,
      y: -200,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level 235',
      localize: false,
      maxWidth: 251,
      maxHeight: 63,
      maxFontSize: 34,
      icons: [],
      style: {
        fontSize: 29,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#1f3f69',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: '#b83500',
        dropShadowDistance: 3,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '05010f98-1625-496a-859f-8d4933433706',
      data: ''
    },
    {
      id: '1a1bb1f4-42aa-43dc-8aa6-1b0fce8e8cd2',
      type: 'Container',
      name: 'starsContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '05010f98-1625-496a-859f-8d4933433706',
      data: ''
    },
    {
      id: '3b9dbbb0-b7f5-4938-89c7-e9582233102a',
      type: 'Sprite',
      name: 'closeButton',
      nameSpace: '',
      className: '',
      x: 361,
      y: -252,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'UI_Christmas_intro_X',
      parent: '05010f98-1625-496a-859f-8d4933433706',
      data: ''
    },
    {
      id: '45738842-40d3-4133-a792-fc6bc7956853',
      type: 'Container',
      name: 'titleContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: -100,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '05010f98-1625-496a-859f-8d4933433706',
      data: ''
    },
    {
      id: 'ef1f6c70-0f5e-4a02-9154-17ec19bd24e6',
      type: 'Container',
      name: 'boostersContainer',
      nameSpace: '',
      className: '',
      x: -4,
      y: 44,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '05010f98-1625-496a-859f-8d4933433706',
      data: ''
    },
    {
      id: '15be72c1-a4a7-421a-94d4-3e4c908b941a',
      type: 'Sprite',
      name: 'character',
      nameSpace: '',
      className: '',
      x: -515,
      y: 380,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.05,
        y: 1.05
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Christmas_Girl_PRELEVEL',
      parent: '05010f98-1625-496a-859f-8d4933433706',
      data: ''
    },
    {
      id: '8242334c-2df4-4d2c-831e-f78e8456573f',
      type: 'Container',
      name: 'costContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: 192,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '05010f98-1625-496a-859f-8d4933433706',
      data: ''
    },
    {
      id: '69052396-e7fe-4cf4-9329-459be5cdbcfc',
      type: 'Sprite',
      name: 'playFreeContainer',
      nameSpace: '',
      className: '',
      x: -160,
      y: 296,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blank',
      parent: '05010f98-1625-496a-859f-8d4933433706',
      data: ''
    },
    {
      id: '6635b2ef-0304-4c20-bb80-a1e9f6eea59f',
      type: 'Sprite',
      name: 'playContainer',
      nameSpace: '',
      className: '',
      x: 160,
      y: 296,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blank',
      parent: '05010f98-1625-496a-859f-8d4933433706',
      data: ''
    },
    {
      id: 'e6559360-ee28-4423-83d1-ccff333c9056',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -665,
      y: 250,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Christmas_snow_2_layer',
      parent: '05010f98-1625-496a-859f-8d4933433706',
      data: ''
    },
    {
      id: '5ae86568-bf9b-468e-a16b-ab71f83c1ff8',
      type: 'Text',
      name: 'hardLevelText',
      nameSpace: '',
      className: '',
      x: 0,
      y: -5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Hard Level: 245',
      localize: false,
      maxWidth: 316,
      maxHeight: 63,
      maxFontSize: 34,
      icons: [],
      style: {
        fontSize: 29,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#781F9D',
        strokeThickness: 8,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: '#b83500',
        dropShadowDistance: 3,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'f0c84e06-b3a4-479c-a1da-99e60acb8ab8',
      data: ''
    },
    {
      id: 'b4c7adb7-0429-4315-8fb6-c951e46f829d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'popup_underlay_booster',
      parent: '6fa403cc-c81c-4d52-8515-91dc3e7323fc',
      data: ''
    },
    {
      id: 'ac3b9f82-b41c-438d-80d3-5874c242e328',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 23,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'UseTheseBoosters',
      localize: true,
      maxWidth: 495,
      maxHeight: 37,
      maxFontSize: 23,
      icons: [],
      style: {
        fontSize: 23,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#982513',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '6fa403cc-c81c-4d52-8515-91dc3e7323fc',
      data: ''
    },
    {
      id: '5becb955-e4d8-429e-a8ee-33b0f0098ef9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: 'starPlaces',
      x: -144,
      y: -280,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: -10,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'star_base_hard',
      parent: '1a1bb1f4-42aa-43dc-8aa6-1b0fce8e8cd2',
      data: ''
    },
    {
      id: '887461d8-5125-4d74-a43d-0904cf146d35',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: 'starPlaces',
      x: 0,
      y: -296,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'star_base_hard',
      parent: '1a1bb1f4-42aa-43dc-8aa6-1b0fce8e8cd2',
      data: ''
    },
    {
      id: '2c6d667b-2d44-44a9-a8f1-9c172d985dc7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: 'starPlaces',
      x: 144,
      y: -280,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 10,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'star_base_hard',
      parent: '1a1bb1f4-42aa-43dc-8aa6-1b0fce8e8cd2',
      data: ''
    },
    {
      id: 'd77fcf89-6d18-4824-911c-a94d10e91da4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: 'stars',
      x: -144,
      y: -287,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: -10,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'popup_title_star',
      parent: '1a1bb1f4-42aa-43dc-8aa6-1b0fce8e8cd2',
      data: ''
    },
    {
      id: '8a1799a9-3cc3-4d96-8566-f865e212e31e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: 'stars',
      x: 0,
      y: -303,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'popup_title_star',
      parent: '1a1bb1f4-42aa-43dc-8aa6-1b0fce8e8cd2',
      data: ''
    },
    {
      id: '8f2507ff-62cb-4b66-99f7-c4f86003ca07',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: 'stars',
      x: 144,
      y: -287,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 10,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'popup_title_star',
      parent: '1a1bb1f4-42aa-43dc-8aa6-1b0fce8e8cd2',
      data: ''
    },
    {
      id: 'abbc49d3-c4c6-40da-aa7d-0dbe373bfc40',
      type: 'Sprite',
      name: 'titleIcon',
      nameSpace: '',
      className: '',
      x: -183,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'goal_icon',
      parent: '45738842-40d3-4133-a792-fc6bc7956853',
      data: ''
    },
    {
      id: '8ef87949-cb09-492b-99a7-5a230df371fc',
      type: 'Text',
      name: 'titleText',
      nameSpace: '',
      className: '',
      x: 45,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Alle Karten loschen',
      localize: false,
      maxWidth: 563,
      maxHeight: 119,
      maxFontSize: 35,
      icons: [],
      style: {
        fontSize: 29,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#933019',
        strokeThickness: 6,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: '#b83500',
        dropShadowDistance: 3,
        leading: -15,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '45738842-40d3-4133-a792-fc6bc7956853',
      data: ''
    },
    {
      id: '1d5709fd-66bb-43c3-bf34-71bbbe73586d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 53,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'text_bg_short',
      parent: '8242334c-2df4-4d2c-831e-f78e8456573f',
      data: ''
    },
    {
      id: '4d453334-e7ad-4706-b206-6a0cd75bbff5',
      type: 'Text',
      name: 'costLabel',
      nameSpace: '',
      className: '',
      x: -53,
      y: -2,
      anchor: {
        x: 1,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Cost:',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 29,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ba382b',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '8242334c-2df4-4d2c-831e-f78e8456573f',
      data: ''
    },
    {
      id: 'a4c4855f-124c-49b0-85f0-634315f5d5cb',
      type: 'Text',
      name: 'priceText',
      nameSpace: '',
      className: '',
      x: 70,
      y: -2,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Free x 2',
      localize: false,
      maxWidth: 120,
      maxHeight: 45,
      maxFontSize: 29,
      icons: [],
      style: {
        fontSize: 29,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#8c261d',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '8242334c-2df4-4d2c-831e-f78e8456573f',
      data: ''
    },
    {
      id: 'da4dc629-792e-428f-b765-fdbb69359d58',
      type: 'Sprite',
      name: 'coin',
      nameSpace: '',
      className: '',
      x: -17,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'coin_icon',
      parent: '8242334c-2df4-4d2c-831e-f78e8456573f',
      data: ''
    },
    {
      id: 'c28077cd-36ca-4a20-b106-111800ee22db',
      type: 'Sprite',
      name: 'playFreeButton',
      nameSpace: '',
      className: '',
      x: 0,
      y: 5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_medium_purple',
      parent: '69052396-e7fe-4cf4-9329-459be5cdbcfc',
      data: ''
    },
    {
      id: '5a8cca60-2546-4eb9-80e5-b889270ff9c4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -111,
      y: -50,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ad_icon_2',
      parent: '69052396-e7fe-4cf4-9329-459be5cdbcfc',
      data: ''
    },
    {
      id: 'f4c22154-70cc-4c5a-b9b2-a75459e6c891',
      type: 'Sprite',
      name: 'playButton',
      nameSpace: '',
      className: '',
      x: 0,
      y: 5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_medium_green',
      parent: '6635b2ef-0304-4c20-bb80-a1e9f6eea59f',
      data: ''
    },
    {
      id: '53a7f500-4900-482b-814a-666647bfe16b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: 'failContainers',
      x: 48,
      y: 14,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.6,
        y: 1.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'popup_goal_fail_2',
      parent: 'abbc49d3-c4c6-40da-aa7d-0dbe373bfc40',
      data: ''
    },
    {
      id: '6641fe86-7e4f-4a7d-983b-07de8d554aa8',
      type: 'Text',
      name: 'playFreeText',
      nameSpace: '',
      className: '',
      x: 0,
      y: -6,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'PlayFree',
      localize: true,
      maxWidth: 226,
      maxHeight: 71,
      maxFontSize: 48,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#703189',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'c28077cd-36ca-4a20-b106-111800ee22db',
      data: ''
    },
    {
      id: 'dcb5b8f0-d3aa-45fd-b7ed-63b9e971c51a',
      type: 'Text',
      name: 'adsAmount',
      nameSpace: '',
      className: '',
      x: 0,
      y: 34,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '9x available',
      localize: false,
      maxWidth: 226,
      maxHeight: 34,
      maxFontSize: 20,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#703189',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'c28077cd-36ca-4a20-b106-111800ee22db',
      data: ''
    },
    {
      id: '48169862-db2a-4458-8134-5c976489402b',
      type: 'Text',
      name: 'playText',
      nameSpace: '',
      className: '',
      x: 0,
      y: -6,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Play',
      localize: true,
      maxWidth: 226,
      maxHeight: 71,
      maxFontSize: 48,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#187630',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'f4c22154-70cc-4c5a-b9b2-a75459e6c891',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class EventLevelPopupLayout {
  static raw = raw;
  root: PIXI.Container
  sideContainer: PIXI.Container
  bg: PIXI.NineSlicePlane
  headerBg: PIXI.Sprite
  hardLevelNumberBg: PIXI.Sprite
  hardLevelText: PIXI.Text
  levelText: PIXI.Text
  starsContainer: PIXI.Container
  closeButton: PIXI.Sprite
  titleContainer: PIXI.Container
  titleIcon: PIXI.Sprite
  titleText: PIXI.Text
  boostersContainer: PIXI.Container
  character: PIXI.Sprite
  costContainer: PIXI.Container
  costLabel: PIXI.Text
  priceText: PIXI.Text
  coin: PIXI.Sprite
  playFreeContainer: PIXI.Sprite
  playFreeButton: PIXI.Sprite
  playFreeText: PIXI.Text
  adsAmount: PIXI.Text
  playContainer: PIXI.Sprite
  playButton: PIXI.Sprite
  playText: PIXI.Text
  failContainers: (PIXI.Container | PIXI.Sprite)[]
  starPlaces: (PIXI.Sprite)[]
  stars: (PIXI.Sprite)[]

  constructor() {
    populate(this, raw);
  }
}
